import React, {Component, createRef} from 'react';

// CSS
import './Exams.scss';

// Helper
import {setCookie, checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Panel, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import AddCommonExam from './AddCommonExam';
import EditCommonExam from './EditCommonExam';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

// Properties
const properties = require('../../properties.json');

class AllCommonExams extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        globalFilter: null,

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,

        // Data
        data: [],

        getSchoolStages: [],
        selectedSchoolStages:null,
        materialList:[],
        material:null,
        // Update Data
        resend: false,

        // the rows are on their way
        tableLoading: true,

        // adding a question is an action on this page now, not a second entry
        // in the rail: the panel mounts the very same AddCommonExam the
        // /commonQuestions/add route mounts
        addOpen: false,

        // the question being edited, in its own panel over the list
        editId: null,

        // the question the teacher asked to delete, held while the confirm is
        // on screen. The delete behind it is the same call it always was.
        doomed: null,
        deleting: false,

        // which menus are still waiting on their options
        loadingStages: true,
        loadingMaterials: false,
    }

    getExams = (materialId) => {
        var _this = this;
        this.setState({ tableLoading: true });
        // Get Exams From API
        apiFetch("/common-questions", { query: { materialId: materialId } })
        .then(fetchExams => {
            this.setState({
                data: fetchExams,
                tableLoading: false,
            });
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({ tableLoading: false });

            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
        });
    }

    // The browser's own confirm box is gone; the question is asked in the
    // product's own confirm card instead. The delete behind it is unchanged.
    deleteExam = (id) => {
        var _this = this;

        this.setState({ deleting: true });

        apiFetch(`/common-questions/${id}`, { method: "DELETE" })
        .then(() => {
            this.setState({resend: true, doomed: null, deleting: false});
            _this.toast.current.show({severity: 'success', summary: 'تمت العملية', detail: 'تم الحذف بنجاح'});
            this.getExams(this.state.material);
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({ doomed: null, deleting: false });
            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
        });
    }

     getSchoolStages(){
        apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
        .then(grades => {
            this.setState({getSchoolStages : grades, loadingStages: false});
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ loadingStages: false });
        });
     }
     getMaterialByStage(stageId){
        this.setState({ loadingMaterials: true });
        apiFetch("/lookup/materials/by-stage", { query: { stageId } })
        .then(grades => {
            this.setState({materialList : grades, loadingMaterials: false});
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ loadingMaterials: false });
        });
     }
    componentDidMount () {
        document.title = properties.site_name + " | كل الاسئله";
        // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }

        this.getExams(this.state.material);
        this.getSchoolStages()
    }

    render() {
        const { tableLoading, doomed, deleting, editId } = this.state;

        let  schoolStages = this.state.getSchoolStages.map(schoolStage => {
            return {label: schoolStage.name, value: schoolStage.id}});
            let  materials = this.state.materialList.map(material => {
                return {label: material.name, value: material.id}});

        const openAdd = () => this.setState({ addOpen: true });
        const closeAdd = () => {
            this.setState({ addOpen: false });
            // whatever was added while the panel was open belongs in the table
            this.getExams(this.state.material);
        };

        const closeEdit = () => {
            this.setState({ editId: null });
            this.getExams(this.state.material);
        };

        // The two menus that narrow the table sit on the toolbar itself.
        const filters = (
            <>
                <span className="ui-filter is-inline">
                    <Dropdown
                        value={this.state.selectedSchoolStages}
                        options={schoolStages}
                        placeholder="كل المراحل"
                        onChange={(e) =>
                            this.setState({ selectedSchoolStages: e.value, material: null, materialList: [] },
                                () => this.getMaterialByStage(e.value))
                        }
                        name="grade"
                        showClear
                        emptyMessage={<SelectEmpty loading={this.state.loadingStages} />}
                    />
                </span>

                <span className="ui-filter is-inline">
                    <Dropdown
                        value={this.state.material}
                        options={materials}
                        placeholder="كل المواد"
                        onChange={(e) =>
                            this.setState({ material: e.value }, () => this.getExams(e.value))
                        }
                        name="subject"
                        showClear
                        emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                        // the materials belong to a stage, so there is nothing
                        // to choose from until one is picked
                        disabled={!this.state.selectedSchoolStages}
                    />
                </span>
            </>
        );

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="تعديل">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-ml-2" onClick={() => this.setState({ editId: rowData.id })} />
                    </Tip>
                    <Tip text="حذف">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        // the question as it reads, with its answer under it -- both are on
        // the row already, and an answer is the point of the question
        const questionBody = (row) => (
            <span className="ui-row-lead">
                {row.image ? (
                    <img className="thumb" src={row.image} alt="" loading="lazy" />
                ) : (
                    <span className="thumb is-empty" aria-hidden="true">
                        <i className="pi pi-question-circle"></i>
                    </span>
                )}
                <span className="tx">
                    <b>{row.text}</b>
                    <small>{row.answer && row.answer.text ? row.answer.text : 'من غير إجابة'}</small>
                </span>
            </span>
        );

        return (
            <>
                <Header
                    pageName="كل الاسئله الشائعه"
                    action={{ label: "إضافة سؤال", icon: "pi pi-plus", onClick: openAdd }}
                />

                <Toast ref={this.toast}></Toast>

                {/* The form is not copied here -- the panel mounts
                    AddCommonExam itself, so its fields, its uploads and its
                    submit stay exactly as they are on /commonQuestions/add,
                    which still works as its own page. */}
                <Panel
                    visible={this.state.addOpen}
                    onHide={closeAdd}
                    title="إضافة سؤال"
                    subtitle="اكتب السؤال وإجابته، وهيظهر في الجدول بعد الحفظ"
                >
                    {this.state.addOpen ? <AddCommonExam inPanel onSaved={closeAdd} /> : null}
                </Panel>

                {/* editing opens the same form the /commonQuestions/edit/:id
                    route mounts -- the route still works on its own */}
                <Panel
                    visible={!!editId}
                    onHide={closeEdit}
                    title="تعديل السؤال"
                    subtitle="عدّل السؤال أو إجابته واحفظ، والجدول هيتحدّث لوحده"
                >
                    {editId ? (
                        <EditCommonExam inPanel questionId={editId} onSaved={closeEdit} />
                    ) : null}
                </Panel>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? doomed.text : ""}
                    note="السؤال هيتشال نهائياً بإجابته، ومش هينفع ترجع عنه."
                    busy={deleting}
                    onConfirm={() => this.deleteExam(doomed.id)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في الاسئله"
                                    count={tableLoading ? null : `${this.state.data.length} سؤال`}
                                    filters={filters}
                                />

                                <DataTable
                                    sortable
                                    globalFilter={this.state.globalFilter}
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={this.state.data}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10,20,50]}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                    emptyMessage={
                                        tableLoading ? (
                                            <TableWait />
                                        ) : (
                                            <EmptyState
                                                title="لا يوجد اسئله"
                                                hint="ابدأ بإضافة أول سؤال شائع لطلابك"
                                                icon="pi pi-question-circle"
                                                action={{ label: "إضافة سؤال", onClick: openAdd }}
                                            />
                                        )
                                    }
                                >
                                    {/* No per-column filter box: the search in
                                        the toolbar already looks across the
                                        whole table. */}
                                    <Column sortable field="text" body={questionBody} header="السؤال"></Column>
                                    <Column header="تعديل / حذف" body={actionBodyTemplate}></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AllCommonExams;
